module.exports = __webpack_public_path__ + "img/mjjt.4fca17c4.png";